import React from "react";
import { LetterX } from 'tabler-icons-react';

// THIS IS THE MODIFIED VERSION OF visitorlist2
const VisitorList4 = () => {
    return (
        <div className="visitorList">
            {/* <span>VISITOR 1 SECTION</span> */}

            <div className="visitorSection3">
                <ul> 
                    <li>
                        <div className="vBox2 roll-in-blurred-bottom7">
                            <div className="vIcon2"></div>
                            <div className="vNumber2">
                                <span>1st</span><br />
                                <span>Visitor</span>
                            </div>
                            <div className="vInfo">
                                <p>ABDUL RAHIM PRADESH</p>
                            </div>

                            <div className="btnBoxRemove">
                                <button type="button" className="btnRdRemove">
                                    <LetterX size={30} strokeWidth={5} color={'white'} />
                                </button>
                            </div>
                        </div>
                    </li>
                    {/* TEST */}
                    {/* <li>
                        <div className="vBox2 roll-in-blurred-bottom8">
                            <div className="vIcon"></div>
                            <div className="vNumber2">
                                <span>2nd</span><br />
                                <span>Visitor</span>
                            </div>
                            <div className="vInfo">
                                <p>TAN AH MENG</p>
                            </div>
                            
                            <div className="btnBoxRemove">
                                <button type="button" className="btnRdRemove">
                                    <LetterX size={30} strokeWidth={5} color={'white'} />
                                </button>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className="vBox2 roll-in-blurred-bottom9">
                            <div className="vIcon"></div>
                            <div className="vNumber2">
                                <span>3rd</span><br />
                                <span>Visitor</span>
                            </div>
                            <div className="vInfo">
                                <p>MICHEAL EDWARD CRUZ</p>
                            </div>
                            
                            <div className="btnBoxRemove">
                                <button type="button" className="btnRdRemove">
                                    <LetterX size={30} strokeWidth={5} color={'white'} />
                                </button>
                            </div>
                        </div>
                    </li> */}
                    {/* <li>
                        <div className="vBox2 roll-in-blurred-bottom10">
                            <div className="vIcon"></div>
                            <div className="vNumber2">
                                <span>4th</span><br />
                                <span>Visitor</span>
                            </div>
                            <div className="vInfo">
                                <p>TAN AH LOCK</p>
                            </div>
                        </div>
                    </li> */}
                </ul>
            </div>

        </div>
    );
};
export default VisitorList4